import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import { gql } from '@/__generated__/index.ts';
import { useMe } from '@/routes/_app/use-me.ts';

const RequestTerminalAccessMutation = gql(`
  mutation RequestTerminalAccess {
    requestTerminalAccess {
      id
      terminalAccessRequested
    }
  }
`);

export const useRequestTerminalAccess = () => {
  const toast = useToast();
  const me = useMe();

  const [mutate, { loading }] = useMutation(RequestTerminalAccessMutation, {
    onError: () => {
      toast.error({
        title: 'Failed to request terminal access',
      });
    },
    onCompleted: () => {
      toast.success({
        title: 'You are on the waitlist',
        subTitle: 'We will notify you once your access is approved.',
      });
    },
  });

  const requestAccess = () => {
    return mutate({
      optimisticResponse: {
        requestTerminalAccess: {
          id: me.id,
          terminalAccessRequested: true,
          __typename: 'User',
        },
      },
    });
  };

  const alreadyRequested = me.terminalAccessRequested ?? false;

  return { requestAccess, loading, alreadyRequested };
};
